var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('lodash'),
    get = _require.get;

var logger = require('../config/logger');

var WTError = require('../error');

module.exports = function (_ref) {
  var request = _ref.request,
      getUploadUrl = _ref.getUploadUrl,
      completeFileUpload = _ref.completeFileUpload;

  /**
   * Uploads a chunk of the file to S3
   * @param   {Object}  transferOrBoard Transfer or Board item.
   * @param   {Object}  file            Item containing information about number of parts, upload url, etc.
   * @param   {Buffer}  data            File content
   * @param   {Number}  partNumber      Which part number we want to upload
   * @returns {Promise}                 Empty response if everything goes well 🤔
   */
  function uploadPart(transferOrBoard, file, data, partNumber) {
    logger.debug("[".concat(file.name, "] Requesting S3 upload URL for part #").concat(partNumber));
    return getUploadUrl(transferOrBoard.id, file.id, partNumber, get(file, 'multipart.id')).then(function (multipartItem) {
      logger.debug("[".concat(file.name, "] Uploading ").concat(data.length, " bytes for part #").concat(partNumber, " to S3"));
      return request.upload(multipartItem.url, data);
    });
  }
  /**
   * Given the content of the file, and the number of parts that must be uploaded to S3,
   * it splits the file into chunks and uploads each part sequentially
   * @param   {Object}  transferOrBoard Transfer or Board item.
   * @param   {Object}  file            Item containing information about number of parts, upload url, etc.
   * @param   {Buffer}  content         File content
   */


  function uploadAllParts(_x, _x2, _x3) {
    return _uploadAllParts.apply(this, arguments);
  }
  /**
   * Given the content of the file, and the number of parts that must be uploaded to S3,
   * it splits the file into chunks and uploads each part sequentially.
   * Completes the file upload at the end.
   * @param   {Object}  transferOrBoard Transfer or Board item.
   * @param   {Object}  file            Item containing information about number of parts, upload url, etc.
   * @param   {Buffer}  content         File content
   * @returns {Promise}                 Empty response if everything goes well 🤔
   */


  function _uploadAllParts() {
    _uploadAllParts = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(transferOrBoard, file, content) {
      var totalParts, partNumber, chunkStart, chunkEnd;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              totalParts = file.multipart.part_numbers;
              logger.debug("[".concat(file.name, "] Splitting file into ").concat(totalParts, " parts. Total size to upload: ").concat(content.length, " bytes."));
              partNumber = 0;

            case 3:
              if (!(partNumber < totalParts)) {
                _context2.next = 13;
                break;
              }

              chunkStart = partNumber * file.multipart.chunk_size;
              chunkEnd = (partNumber + 1) * file.multipart.chunk_size;
              logger.debug("[".concat(file.name, "] Part #").concat(partNumber + 1, " of ").concat(totalParts, ". Bytes from ").concat(chunkStart, " to ").concat(chunkEnd, "."));
              _context2.next = 9;
              return uploadPart(transferOrBoard, file, content.slice(chunkStart, chunkEnd), partNumber + 1);

            case 9:
              logger.debug("[".concat(file.name, "] Uploaded part #").concat(partNumber + 1, " of ").concat(totalParts, " to S3\""));

            case 10:
              partNumber++;
              _context2.next = 3;
              break;

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
    return _uploadAllParts.apply(this, arguments);
  }

  return (
    /*#__PURE__*/
    function () {
      var _uploadFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(transferOrBoard, file, content) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger.info("[".concat(file.name, "] Starting file upload."));
                _context.prev = 1;
                _context.next = 4;
                return uploadAllParts(transferOrBoard, file, content);

              case 4:
                _context.next = 6;
                return completeFileUpload(transferOrBoard, file);

              case 6:
                response = _context.sent;
                logger.info("[".concat(file.name, "] File upload complete."));
                return _context.abrupt("return", response);

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                throw new WTError("There was an error when uploading ".concat(file.name, "."), _context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 11]]);
      }));

      function uploadFile(_x4, _x5, _x6) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }()
  );
};